<template>
  <div class="mobile-floating-buttons">
    <transition name="fade">
      <div v-if="isExpanded" class="floating-menu">
        <button class="floating-item floating-item--orders" @click="goToStock">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14H6v-2h6v2zm4-4H6v-2h10v2zm0-4H6V7h10v2z"/>
          </svg>
          <span class="floating-item__label">{{ $t("mobile.exchange_orders") }}</span>
        </button>
        <button class="floating-item floating-item--pilots" @click="goToPilots">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          <span class="floating-item__label">{{ $t("mobile.exchange_pilots") }}</span>
        </button>
      </div>
    </transition>
    <button
      class="floating-toggle"
      :class="{ 'floating-toggle--active': isExpanded }"
      @click="toggleMenu"
    >
      <span class="floating-toggle__pulse"></span>
      <svg class="floating-toggle__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" fill="currentColor">
        <path d="M0.300312 19.2799L9.90031 9.6799L8.50031 8.25991L7.78031 8.9699C7.6878 9.06261 7.57791 9.13616 7.45694 9.18634C7.33596 9.23652 7.20628 9.26235 7.07531 9.26235C6.94434 9.26235 6.81466 9.23652 6.69369 9.18634C6.57271 9.13616 6.46283 9.06261 6.37031 8.9699L5.66031 8.25991C5.56761 8.16739 5.49406 8.0575 5.44388 7.93653C5.3937 7.81556 5.36787 7.68587 5.36787 7.55491C5.36787 7.42394 5.3937 7.29425 5.44388 7.17328C5.49406 7.05231 5.56761 6.94242 5.66031 6.84991L11.3203 1.18991C11.4128 1.0972 11.5227 1.02365 11.6437 0.973472C11.7647 0.923291 11.8943 0.897461 12.0253 0.897461C12.1563 0.897461 12.286 0.923291 12.4069 0.973472C12.5279 1.02365 12.6378 1.0972 12.7303 1.18991L13.4403 1.89991C13.8303 2.28991 13.8303 2.91991 13.4403 3.30991L12.7303 3.99991L14.1503 5.4299C14.2428 5.3372 14.3527 5.26365 14.4737 5.21347C14.5947 5.16329 14.7243 5.13746 14.8553 5.13746C14.9863 5.13746 15.116 5.16329 15.2369 5.21347C15.3579 5.26365 15.4678 5.3372 15.5603 5.4299C15.9503 5.8199 15.9503 6.45991 15.5603 6.84991L16.9703 8.25991L17.6803 7.54991C18.0703 7.15991 18.7103 7.15991 19.1003 7.54991L19.8003 8.25991C20.1903 8.64991 20.1903 9.2899 19.8003 9.6799L14.1503 15.3299C13.7603 15.7199 13.1203 15.7199 12.7303 15.3299L12.0303 14.6299C11.9354 14.5376 11.8599 14.4273 11.8083 14.3053C11.7568 14.1834 11.7302 14.0523 11.7302 13.9199C11.7302 13.7875 11.7568 13.6565 11.8083 13.5345C11.8599 13.4125 11.9354 13.3022 12.0303 13.2099L12.7303 12.4999L11.3203 11.0899L1.71031 20.6999C1.6178 20.7926 1.50791 20.8662 1.38694 20.9163C1.26596 20.9665 1.13628 20.9923 1.00531 20.9923C0.874344 20.9923 0.744662 20.9665 0.623688 20.9163C0.502715 20.8662 0.392826 20.7926 0.300312 20.6999C-0.0896875 20.3099 -0.0896875 19.6699 0.300312 19.2799ZM18.0003 17.9999C18.5307 17.9999 19.0395 18.2106 19.4145 18.5857C19.7896 18.9608 20.0003 19.4695 20.0003 19.9999V20.9999H10.0003V19.9999C10.0003 19.4695 10.211 18.9608 10.5861 18.5857C10.9612 18.2106 11.4699 17.9999 12.0003 17.9999H18.0003Z"/>
      </svg>
    </button>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import router from "@/router";

export default defineComponent({
  name: "MobileExchangeBar",
  setup() {
    const isExpanded = ref(false);

    const toggleMenu = () => {
      isExpanded.value = !isExpanded.value;
    };

    const goToStock = () => {
      router.push({ name: "stock" });
      isExpanded.value = false;
    };

    const goToPilots = () => {
      router.push({ name: "pilot-offers" });
      isExpanded.value = false;
    };

    return {
      isExpanded,
      toggleMenu,
      goToStock,
      goToPilots,
    };
  },
});
</script>

<style scoped lang="scss">
.mobile-floating-buttons {
  display: none;
  position: relative;
  margin-left: auto;
  padding-left: 14px;
  z-index: 9999;

  @media screen and (max-width: 850px) {
    display: flex;
  }
}

.floating-toggle {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #112baf 0%, #1e3fd1 100%);
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(17, 43, 175, 0.4);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 20px rgba(17, 43, 175, 0.5);

    .floating-toggle__pulse {
      animation-play-state: paused;
    }
  }

  &:active {
    transform: scale(0.95);
  }

  &--active {
    background: linear-gradient(135deg, #e85d04 0%, #f77f00 100%);
    box-shadow: 0 4px 15px rgba(232, 93, 4, 0.4);

    .floating-toggle__pulse {
      animation: none;
    }

    &:hover {
      box-shadow: 0 6px 20px rgba(232, 93, 4, 0.5);
    }
  }

  &__pulse {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: linear-gradient(135deg, #112baf 0%, #1e3fd1 100%);
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    z-index: -1;
  }

  &__icon {
    width: 18px;
    height: 18px;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.3);
    opacity: 0;
  }
}

.floating-menu {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.floating-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border: none;
  border-radius: 28px;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  &:hover {
    transform: translateX(-5px);
  }

  &:active {
    transform: scale(0.95);
  }

  &--orders {
    background: linear-gradient(135deg, #112baf 0%, #1e3fd1 100%);
    animation-delay: 0.05s;
    opacity: 0;

    &:hover {
      box-shadow: 0 6px 16px rgba(17, 43, 175, 0.4);
    }
  }

  &--pilots {
    background: linear-gradient(135deg, #e85d04 0%, #f77f00 100%);
    animation-delay: 0.1s;
    opacity: 0;

    &:hover {
      box-shadow: 0 6px 16px rgba(232, 93, 4, 0.4);
    }
  }

  &__label {
    white-space: nowrap;
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 400px) {
  .floating-item {
    padding: 8px 14px;
    font-size: 12px;
    gap: 8px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
